import script from "./Template1.vue?vue&type=script&setup=true&lang=js"
export * from "./Template1.vue?vue&type=script&setup=true&lang=js"

import "./Template1.vue?vue&type=style&index=0&id=48d919fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d919fe"]])

export default __exports__